module.exports = __webpack_public_path__ + "static/gavin-94da06c4a064f505e059debac5ccb5ff.jpg";